<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs12>
      <v-text-field
        v-model="name"
        :label="$t('Name')"
        outline
      />
    </v-flex>
    <v-flex xs12>
      <v-text-field
        v-model="code"
        :label="$t('Code')"
        outline
      />
    </v-flex>
    <v-flex xs12>
      <v-text-field
        v-model="iso"
        :label="$t('Locale ISO')"
        :error-messages="localeValidation"
        outline
      />
    </v-flex>
    <v-flex xs12>
      <v-select
        v-model="flag"
        :label="$t('Flag')"
        :items="countriesFlags"
        :item-text="(item) => {
          return item.emoji + ' ' + item.name
        }"
        item-value="emoji"
        outline
      />
    </v-flex>
    <v-flex xs12>
      <v-radio-group
        v-model="dir"
        :label="$t('Direction')"
      >
        <v-radio
          label="LTR"
          value="ltr"
        />
        <v-radio
          label="RTL"
          value="rtl"
        />
      </v-radio-group>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LanguageForm',

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        code: '',
        flag: '',
        iso: '',
        dir: ''
      })
    }
  },
  computed: {
    ...mapGetters(['countries', 'defaultLang']),

    name: {
      set (value) {
        this.$emit('input', { ...this.value, ...{ name: value } })
      },
      get () {
        return this.value.name
      }
    },

    code: {
      set (value) {
        this.$emit('input', { ...this.value, ...{ code: value } })
      },
      get () {
        return this.value.code
      }
    },

    flag: {
      set (value) {
        this.$emit('input', { ...this.value, ...{ flag: value } })
      },
      get () {
        return this.value.flag
      }
    },

    iso: {
      set (value) {
        this.$emit('input', { ...this.value, ...{ iso: value } })
      },
      get () {
        return this.value.iso
      }
    },

    dir: {
      set (value) {
        this.$emit('input', { ...this.value, ...{ dir: value } })
      },
      get () {
        return this.value.dir
      }
    },

    localeValidation () {
      if (!this.iso) {
        return ''
      }

      const valid = this.iso.match('^[a-z]{2}-[A-Z]{2}$')
      return valid ? '' : this.$t('Invalid locale format. Valid format: `xx-XX`')
    },

    countriesFlags () {
      return this.countries.filter(country => country.emoji)
    }
  }
}
</script>
